import { render } from "./excel.vue?vue&type=template&id=8bf27d98&scoped=true"
import script from "./excel.vue?vue&type=script&lang=js"
export * from "./excel.vue?vue&type=script&lang=js"

import "./excel.vue?vue&type=style&index=0&id=8bf27d98&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bf27d98"]])

export default __exports__